// Service
export const FETCH_SERVICE = 'fetchService'
export const FETCH_SERVICES = 'fetchServices'
export const SERVICE_RESET_STATE = 'serviceReset'
export const FETCH_FILTERS_SETTINGS = 'fetchFilterSettings'
export const FETCH_FILTER_DATA = 'fetchFilterData'
export const SEND_FILTER_SELECTED = 'sendFilterSelected'
export const SEND_SEARCH_TIME = 'sendSearchTime'

export const SEND_STORE_QUERY_PARAMS = 'sendStoreQueryParams'

export const FETCH_ORGANIZATION = 'fetchOrganization'
export const FETCH_LOCATION = 'fetchLocation'
export const FETCH_LOCATIONS = 'fetchLocations'
